<template>
  <div class="card-modal__company">
    <h3>{{ $t('card_modal.ui.account') }}</h3>
    <p>{{ account.name }}</p>
  </div>
</template>

<script>
export default {
  name: 'CardModalCompany',
  props: {
    account: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style scoped>
.card-modal__company h3 {
  font-size: 12px;
  letter-spacing: 0.3px;
}

.card-modal__company p {
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: var(--c-secondary-700);
  height: 30px;
  padding: 10px;
  background-color: var(--c-secondary-400);
  border-radius: 4px;
}
</style>
